<template>
  <div
    v-click-outside="() => { popupOpen = false }"
    class="facetFilter filterWrapper"
    :class="{ open: popupOpen }"
  >
    <button
      class="no-button title"
      @click="popupOpen = !popupOpen"
    >
      <span>{{ name }}</span>
      <span
        v-if="nbChecked"
        class="nbChecked"
      >
        {{ nbChecked }}
      </span>
      <i class="dsio-angle-down icon-arrow" />
    </button>
    <div :class="{ 'filter--popup': !moreFilter }">
      <button
        v-if="!moreFilter"
        class="no-button title"
        @click="popupOpen = !popupOpen"
      >
        <span>{{ name }}</span>
        <span
          v-if="nbChecked"
          class="nbChecked"
        >
          {{ nbChecked }}
        </span>
        <i class="dsio-angle-up icon-arrow" />
      </button>
      <div
        v-for="({ name: optionName, count, classes, fieldset }, key) in facets"
        :key="key"
        class="facetFilterCheckbox"
        :class="classes"
      >
        <template v-if="fieldset">
          <p class="fieldset--title">
            {{ optionName }}
          </p>
        </template>
        <template v-else>
          <input
            :id="instanceId+'_'+key"
            v-model="selected"
            type="checkbox"
            :value="key"
          >
          <label
            class="lgrid-noGutter-center-noWrap"
            :for="instanceId+'_'+key"
          >
            <span class="label lcol">
              {{ optionName }}
            </span>
            <span
              v-if="conf.counter"
              class="count lcol-auto"
            >
              ({{ count }})
            </span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import baseEngines from './baseEngines';

export default {
  name: 'FacetFilterCheckbox',
  mixins: [baseEngines],
  props: {
    conf: {
      type: Object,
      default: () => {},
    },
    facets: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    requestValue: {
      type: Array,
      default: () => [],
    },
    moreFilter: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      popupOpen: false,
    };
  },
  computed: {
    nbChecked () {
      return this.selected.length;
    },
    selected: {
      get () {
        const value = this.filterData || '';
        return value.length ? value.split('~') : [];
      },
      set (filterIds) {
        this.setData(filterIds);
        this.setContext(filterIds);
      },
    },
  },
  created () {
    // If requestValue is not empty
    if (this.requestValue !== null) {
      // Restore selection
      this.selected = this.requestValue;
    }
  },
  methods: {
    setData (filterIds) {
      this.filterData = filterIds.join('~');
    },
    setContext (filterIds) {
      const contextEntries = Object.values(this.facets).filter(facet => filterIds.indexOf(facet.id) !== -1);
      this.updateContext(contextEntries);
    },
  },
};
</script>
